/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Machine_Col_RemainingInputs */

const vi_station_machine_col_remaining = /** @type {(inputs: Station_Machine_Col_RemainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Còn lại`)
};

/**

* @param {Station_Machine_Col_RemainingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_machine_col_remaining = /** @type {((inputs?: Station_Machine_Col_RemainingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Machine_Col_RemainingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_machine_col_remaining(inputs)
});